<template>
  <div v-if="auth[type] || authorize" class="operation-icon-btn-wrap">
    <div class="operation-icon-btn-box">
      <el-tooltip effect="dark" :placement="placement" :content="text || Lang.btn[type]">
        <svg aria-hidden="true" :fill="computedColor" @mouseover="handeleMousehover" @mouseout="handeleMousehout" :style="{
          width: width || size,
          height: height || size,
          cursor: 'pointer',
          margin: '2px 6px',
          color: computedColor,
        }">
          <use :xlink:href="symbolId" />
        </svg>
      </el-tooltip>
    </div>
    <div v-if="divider" class="divider"></div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { Lang } from "@/lang/lang";
const props = defineProps({
  auth: {
    type: Object,
    default () {
      return {}
    }
  },
  authorize: { // 是否有权限
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "",
  },
  text: { // 显示的文字
    type: String,
    default: "",
  },
  icon: { // 图标名
    type: String,
    default: "",
  },
  color: {
    type: String,
    default: "",
  },
  width: {
    type: String,
    default: "",
  },
  height: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "20px",
  },
  placement: {
    type: String,
    default: "top",
  },
  divider: {
    type: Boolean,
    default: false
  },
  hoverColor: {
    type: String,
    default: "",
  }
});
const isHovering = ref(false)
const symbolId = computed(() => `#icon-${props.icon || props.type}`);
const computedColor = computed(() => {
  if (isHovering.value) {
    return props.hoverColor || '#2684FC';
  }
  if (props.color) {
    return props.color;
  } else if (props.type === 'delete') {
    return '#FF2D46'
  }
  return 'black'
});
const handeleMousehover = () => {
  isHovering.value = true;
}
const handeleMousehout = () => {
  isHovering.value = false;
}
</script>
<style lang="scss">
.operation-icon-btn-wrap {
  display: flex;
  align-items: center;
  .operation-icon-btn-box {
    cursor: pointer;
    .el-only-child__content {
      display: flex;
      align-items: center;
    }
  }
  .divider {
    width: 1px;
    height: 12px;
    background-color: #E3E8F2;
    margin-left: 2px;
  }
}
</style>